import React from "react";
import Navbar from "./navbar.js";

import "../static/css/bootstrap-icons.css";
import "../static/css/bootstrap.min.css";
import "../static/css/owl.theme.default.min.css";
import "../static/css/templatemo-medic-care.css";

// import "../static/js";

function LandingPage() {
  return (
    <div>
      <Navbar />
      <section className="hero" id="hero">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div
                id="myCarousel"
                className="carousel slide carousel-fade"
                data-bs-ride="carousel"
              >
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <img
                      style={{
                        marginTop: "240px",
                        width: "230px",
                        marginLeft: "140px",
                      }}
                      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTsqykttwT2Tc8_36sWCv3lp_Jzy11ujyeM9w&usqp=CAU"
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                </div>
              </div>

              <div className="heroText " style={{ top: "250px" }}>
                <h1 className="mt-auto mb-2">
                  Better
                  <div className="animated-info">
                    <span className="animated-item">health</span>
                    <span className="animated-item">days</span>
                    <span className="animated-item">lives</span>
                  </div>
                </h1>

                <p className="mb-4">
                  Elixir is a one-stop solution for making our medical system
                  more efficient, transparent and accountable
                </p>

                <div className="heroLinks d-flex flex-wrap align-items-center">
                  <a
                    className="custom-link me-4"
                    href="#about"
                    data-hover="Learn More"
                  >
                    Learn More
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-padding" id="about">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              <h2 className="mb-lg-3 mb-3">About Elixir</h2>

              <p>
                We present Elixir, a one-stop platform to combat several
                administrative issues that plague our medical system.We plan to
                tackle this lack of transparency, honesty and morality by using
                blockchain technology.
              </p>

              <p>
                Our platform aims to introduce blockchain technology into
                various spheres of the medical system to ensure more efficiency,
                accountability and transparency.
              </p>
            </div>

            <div className="col-lg-4 col-md-5 col-12 mx-auto">
              <div className="featured-circle bg-white shadow-lg d-flex justify-content-center align-items-center">
                <p className="featured-text">
                  <span className="featured-number">1</span>Platform
                  <br />
                  to revolutionize the medical system
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* 
      <section className="gallery">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-6 ps-0">
              <img
                src="images/gallery/medium-shot-man-getting-vaccine.jpg"
                className="img-fluid galleryImage"
                alt="get a vaccine"
                title="get a vaccine for yourself"
              />
            </div>

            <div className="col-lg-6 col-6 pe-0">
              <img
                src="images/gallery/female-doctor-with-presenting-hand-gesture.jpg"
                className="img-fluid galleryImage"
                alt="wear a mask"
                title="wear a mask to protect yourself"
              />
            </div>
          </div>
        </div>
      </section> */}

      <section className="section-padding pb-0" id="timeline">
        <div className="container">
          <div className="row">
            <h2 className="text-center mb-lg-5 mb-4">Our Services</h2>

            <div className="timeline">
              <div className="row g-0 justify-content-end justify-content-md-around align-items-start timeline-nodes">
                <div className="col-9 col-md-5 me-md-4 me-lg-0 order-3 order-md-1 timeline-content bg-white shadow-lg">
                  <h3 className=" text-light">Check Resources</h3>

                  <p>
                    Check the number of beds,oxygen cylinders and ventilators at
                    various hospitals
                  </p>
                </div>

                <div className="col-3 col-sm-1 order-2 timeline-icons text-md-center">
                  <i className="bi-patch-check-fill timeline-icon"></i>
                </div>

                <div className="col-9 col-md-5 ps-md-3 ps-lg-0 order-1 order-md-3 py-4 timeline-date"></div>
              </div>

              <div className="row g-0 justify-content-end justify-content-md-around align-items-start timeline-nodes my-lg-5 my-4">
                <div className="col-9 col-md-5 ms-md-4 ms-lg-0 order-3 order-md-1 timeline-content bg-white shadow-lg">
                  <h3 className=" text-light">Transforming supply chains</h3>

                  <p>
                    We use blockchain to make supply chains
                    efficient,transparent and curb malpractices
                  </p>
                </div>

                <div className="col-3 col-sm-1 order-2 timeline-icons text-md-center">
                  <i className="bi-book timeline-icon"></i>
                </div>

                <div className="col-9 col-md-5 pe-md-3 pe-lg-0 order-1 order-md-3 py-4 timeline-date"></div>
              </div>

              <div className="row g-0 justify-content-end justify-content-md-around align-items-start timeline-nodes">
                <div className="col-9 col-md-5 me-md-4 me-lg-0 order-3 order-md-1 timeline-content bg-white shadow-lg">
                  <h3 className=" text-light">Claim Insurance</h3>

                  <p>
                    We make claiming insurance an easy, smooth and hassle-free
                    process.
                  </p>
                </div>

                <div className="col-3 col-sm-1 order-2 timeline-icons text-md-center">
                  <i className="bi-file-medical timeline-icon"></i>
                </div>

                <div className="col-9 col-md-5 ps-md-3 ps-lg-0 order-1 order-md-3 py-4 timeline-date"></div>
              </div>

              <div className="row g-0 justify-content-end justify-content-md-around align-items-start timeline-nodes my-lg-5 my-4">
                <div className="col-9 col-md-5 ms-md-4 ms-lg-0 order-3 order-md-1 timeline-content bg-white shadow-lg">
                  <h3 className=" text-light">Covid-19 Hospitals</h3>

                  <p className="mb-0 pb-0">
                    In case a hospital runs out of resources, we inform nearby
                    hospitals regarding this shortage, so they can ramp up
                    resource acquisition
                  </p>
                </div>

                <div className="col-3 col-sm-1 order-2 timeline-icons text-md-center">
                  <i className="bi-globe timeline-icon"></i>
                </div>

                <div className="col-9 col-md-5 pe-md-3 pe-lg-0 order-1 order-md-3 py-4 timeline-date"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default LandingPage;
